module.exports = __webpack_public_path__ + "resources/bootstrap/fonts/glyphicons-halflings-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bootstrap/fonts/glyphicons-halflings-regular.woff2
// module id = 334
// module chunks = 0